// BC-3025: the host->opts TABLE now lives in `shared/utils/hostOverrideOpts.js`
// so the BACKEND login state machine can read the same single definition. The
// choose-tenant decision is made server-side in
// `backend/src/services/login/utils/nextFlowHelper.js`, which is why a
// frontend-only table could never honor `disableTenantChoice` there.
//
// This module remains the FRONTEND BINDING of that table: it is the one place
// that couples the table to `window.location.hostname`. It cannot be folded
// into `shared/` because `shared/` is also imported by the backend, where there
// is no `window` and where the correct host comes from the request
// Origin/Referer headers, not from a process-wide global.
//
// >>> To ADD or EDIT a host entry, edit `shared/utils/hostOverrideOpts.js`. <<<
import { resolveHostOverrideOpts } from 'shared/utils/hostOverrideOpts';

export { hostOverrides } from 'shared/utils/hostOverrideOpts';

const { hostname } = window.location;
export const hostOverrideOpts = resolveHostOverrideOpts(hostname);
